<template>
  <nav
    class="navbar is-fixed-top is-primary"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item" style="width: 145px;">
        <img
          src="https://image.fantasy-tours.com/Content/styles/images/logo.png"
          :alt="$t('message.fantasy_backend')"
          height="28"
        />
      </router-link>

      <router-link v-if="$auth.check()" to="/" class="navbar-item">
        <p class="has-text-weight-bold has-text-white">
          {{
            isMobileDevice()
              ? $t('message.fantasy_backend')
              : $t('message.fantasy_system')
          }}
        </p>
      </router-link>
      <router-link
        v-if="
          $auth.check() && hasPermission(PERMISSION_TYPE.DashboardTourControl)
        "
        to="/tour-control"
        class="navbar-item"
      >
        <p class="has-text-weight-bold has-text-warning">
          {{
            isMobileDevice()
              ? $t('message.tour_control')
              : $t('message.tour_control_table')
          }}
        </p>
      </router-link>
      <a
        v-if="
          $auth.check() &&
            hasPermission(PERMISSION_TYPE.DashboardMeetingRoomSchedule)
        "
        href="#"
        class="navbar-item"
        @click.prevent="redirectToAdmin2('meeting-room-schedule')"
      >
        <p class="has-text-weight-bold has-text-warning">
          {{
            isMobileDevice()
              ? $t('attributes.meeting_room')
              : $t('attributes.meeting_room_booking')
          }}
        </p>
      </a>
      <a
        v-if="$auth.check()"
        href="#"
        class="navbar-item"
        @click="isTagModalActive = true"
      >
        <p class="has-text-weight-bold has-text-warning">
          標籤
        </p>
      </a>
      <a
        v-if="$auth.check()"
        href="#"
        class="navbar-item"
        @click="isQuestionnaireModalActive = true"
      >
        <p class="has-text-weight-bold has-text-warning">
          意調表
        </p>
      </a>
      <a
        v-if="$auth.check()"
        href="#"
        class="navbar-item"
        @click="isCustomsModalActive = true"
      >
        <p class="has-text-weight-bold has-text-warning">
          日本海關單
        </p>
      </a>
      <a
        v-if="
          $auth.check() &&
            hasPermission(PERMISSION_TYPE.DashboardRemittanceOrder)
        "
        href="#"
        class="navbar-item"
        @click="isRemittanceModalActive = true"
      >
        <p class="has-text-weight-bold has-text-warning">
          匯款單
        </p>
      </a>
      <a
        v-if="$auth.check()"
        href="#"
        class="navbar-item"
        @click="redirectToAdmin2('home')"
      >
        <p class="has-text-weight-bold has-text-warning">
          後台 2.0
        </p>
      </a>
      <a
        href="#"
        class="navbar-item"
        style="display: none"
        @click="linkLineNotify"
      >
        <p class="has-text-weight-bold has-text-warning">
          綁定Line
        </p>
      </a>
      <a
        v-if="$auth.check() && isAccountant"
        href="#"
        class="navbar-item"
        @click="onSendLineNotify"
      >
        <p class="has-text-weight-bold has-text-warning">
          送出通知
        </p>
      </a>
      <a
        role="button"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarMenu"
        :class="['navbar-burger', 'burger', { 'is-active': showNav }]"
        @click="showNav = !showNav"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarMenu" class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-end">
        <div v-if="$auth.check()" class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            {{ username }}
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" to="/profile">
              {{ $t('message.my_profile') }}
            </router-link>
            <hr class="navbar-divider" />
            <a class="navbar-item" @click="logout">
              {{ $t('message.logout') }}
            </a>
          </div>
        </div>
        <router-link v-else class="navbar-item" to="/login">
          {{ $t('message.login') }}
        </router-link>

        <div
          v-if="enable_locales"
          class="navbar-item has-dropdown is-hoverable"
        >
          <a class="navbar-link">
            {{ $t('message.select_locales') }}
          </a>
          <div class="navbar-dropdown is-right">
            <a
              v-for="loc in locales"
              :key="loc.code"
              :class="['navbar-item', { 'is-active': loc.code === locale }]"
              @click="setLanguage(loc.code)"
            >
              {{ loc.name }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="isTagModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <template #default="props">
        <form action="">
          <div class="modal-card" style="width: 480px;">
            <header class="modal-card-head">
              <p class="modal-card-title">行李與護照標籤</p>
              <button
                type="button"
                class="delete"
                @click="isTagModalActive = false"
              />
            </header>
            <section class="modal-card-body">
              <div class="block">
                <b-upload v-model="file" accept=".xls,.xlsx" required>
                  <a class="button is-second is-link" style="cursor: pointer">
                    <b-icon icon="upload"></b-icon>
                    <span>上傳團員名冊</span>
                  </a>
                </b-upload>
                <b-checkbox v-model="displayTel" class="ml-4" required>
                  <p class="has-text-black">列印電話</p>
                </b-checkbox>
                <b-checkbox
                  v-model="displayAddress"
                  style="display: none"
                  required
                >
                  <p class="has-text-black">列印住址</p>
                </b-checkbox>
              </div>
              <div class="block has-text-danger pl-1">
                <p>團員名冊在哪裡?</p>
                <p>
                  <br />
                  登入科威系統 > 1.D(團銷管理) > 2.A(團體銷售控管) >
                  <br />
                  3.輸入團號找到該團 > 4.印表 > 5.團員名冊 > 6.輸出Excel
                </p>
                <p class="control">
                  <a
                    :href="helpImageUrl('DownloadList2.jpg')"
                    title="團員名冊在哪裡"
                    @click.prevent="onClickImage('DownloadList2.jpg')"
                  >
                    <img
                      :src="helpImageUrl('DownloadList2.jpg')"
                      alt="團員名冊在這裡"
                      width="128"
                    />
                  </a>
                </p>
              </div>
            </section>
            <footer class="modal-card-foot">
              <b-button label="取消" @click="isTagModalActive = false" />
              <b-button
                label="新版標籤"
                type="is-primary"
                :disabled="!file"
                @click="onTagImport(2)"
              />
              <b-button
                label="舊版標籤"
                :disabled="!file"
                @click="onTagImport(1)"
              />
              <b-tag>
                <span style="color: blue; font-size: 12px;">
                  同時產生護照標籤與行李標籤
                </span>
              </b-tag>
            </footer>
          </div>
        </form>
      </template>
    </b-modal>
    <b-modal
      v-model="isQuestionnaireModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <template #default="props">
        <form action="">
          <div class="modal-card" style="width: 480px;">
            <header class="modal-card-head">
              <p class="modal-card-title">產生意見調查表</p>
              <button
                type="button"
                class="delete"
                @click="isQuestionnaireModalActive = false"
              />
            </header>
            <section class="modal-card-body">
              <div class="block">
                <b-field>
                  <b-upload v-model="file" accept=".xls,.xlsx" required>
                    <a class="button is-second is-link" style="cursor: pointer">
                      <b-icon icon="upload"></b-icon>
                      <span>上傳團員名冊</span>
                    </a>
                  </b-upload>
                  <b-input
                    v-model="tourLeader"
                    name="TourLeader"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.tour_leader') +
                        $t('attributes.fullname')
                    "
                    style="margin-left: 20px;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block">
                <b-field>
                  <p class="control">
                    <span class="button is-static">
                      {{ $t('attributes.set_right') }}
                    </span>
                  </p>
                  <b-input
                    v-model="width"
                    name="Width"
                    style="width: 80px;"
                  ></b-input>
                  <p class="control ml-4">
                    <span class="button is-static">
                      {{ $t('attributes.set_down') }}
                    </span>
                  </p>
                  <b-input
                    v-model="height"
                    name="Height"
                    style="width: 80px;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block has-text-danger pl-1">
                <p>團員名冊在哪裡?</p>
                <p>
                  <br />
                  登入科威系統 > 1.D(團銷管理) > 2.A(團體銷售控管) >
                  <br />
                  3.輸入團號找到該團 > 4.印表 > 5.團員名冊 > 6.輸出Excel
                </p>
                <p class="control">
                  <a
                    :href="helpImageUrl('DownloadList2.jpg')"
                    title="團員名冊在哪裡"
                    @click.prevent="onClickImage('DownloadList2.jpg')"
                  >
                    <img
                      :src="helpImageUrl('DownloadList2.jpg')"
                      alt="團員名冊在這裡"
                      width="128"
                    />
                  </a>
                </p>
              </div>
            </section>
            <footer class="modal-card-foot">
              <b-button label="取消" @click="closeQuestionnaire" />
              <b-button
                label="產生意見調查表"
                type="is-primary"
                :disabled="!file"
                @click="onQuestionnaireImport"
              />
              <b-tag>
                <span style="color: blue; font-size: 14px;">
                  會自動忽略領隊
                </span>
              </b-tag>
            </footer>
          </div>
        </form>
      </template>
    </b-modal>
    <b-modal
      v-model="isCustomsModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <template #default="props">
        <form action="">
          <div class="modal-card" style="width: 480px;">
            <header class="modal-card-head">
              <p class="modal-card-title">產生日本海關單</p>
              <button type="button" class="delete" @click="closeCustoms" />
            </header>
            <section class="modal-card-body">
              <div class="block">
                <b-field>
                  <b-upload v-model="file" accept=".xls,.xlsx" required>
                    <a class="button is-second is-link" style="cursor: pointer">
                      <b-icon icon="upload"></b-icon>
                      <span>上傳團員名冊</span>
                    </a>
                  </b-upload>
                </b-field>
              </div>
              <div class="block">
                <b-field>
                  <p class="control">
                    <span class="button is-static">搭乘班機</span>
                  </p>
                  <b-input
                    v-model="airLine"
                    name="airLine"
                    style="width: 100px;"
                  ></b-input>
                  <p class="control ml-4">
                    <span class="button is-static">出發地</span>
                  </p>
                  <b-input
                    v-model="depLocation"
                    name="depLocation"
                    style="width: 100px;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block">
                <b-field>
                  <p class="control">
                    <span class="button is-static">入國日</span>
                  </p>
                  <b-input
                    v-model="depDate1"
                    name="depDate1"
                    placeholder="年"
                    style="width: 100px;"
                  ></b-input>
                  <b-input
                    v-model="depDate2"
                    name="depDate2"
                    placeholder="月"
                    style="width: 100px;"
                  ></b-input>
                  <b-input
                    v-model="depDate3"
                    name="depDate3"
                    placeholder="日"
                    style="width: 100px;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block">
                <b-field>
                  <p class="control">
                    <span class="button is-static">住宿地點</span>
                  </p>
                  <b-input
                    v-model="hotel"
                    name="hotel"
                    style="width: 100%;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block">
                <b-field>
                  <p class="control">
                    <span class="button is-static">住宿電話</span>
                  </p>
                  <b-input
                    v-model="hotelTel1"
                    name="hotelTel1"
                    style="width: 100px;"
                  ></b-input>
                  <b-input
                    v-model="hotelTel2"
                    name="hotelTel2"
                    style="width: 100px;"
                  ></b-input>
                  <b-input
                    v-model="hotelTel3"
                    name="hotelTel3"
                    style="width: 100px;"
                  ></b-input>
                </b-field>
              </div>
              <div class="block has-text-danger pl-1">
                <p>團員名冊在哪裡?</p>
                <p>
                  <br />
                  登入科威系統 > 1.D(團銷管理) > 2.A(團體銷售控管) >
                  <br />
                  3.輸入團號找到該團 > 4.印表 > 5.團員名冊 > 6.輸出Excel
                </p>
                <p class="control">
                  <a
                    :href="helpImageUrl('DownloadList2.jpg')"
                    title="團員名冊在哪裡"
                    @click.prevent="onClickImage('DownloadList2.jpg')"
                  >
                    <img
                      :src="helpImageUrl('DownloadList2.jpg')"
                      alt="團員名冊在這裡"
                      width="128"
                    />
                  </a>
                </p>
              </div>
            </section>
            <footer class="modal-card-foot">
              <b-button label="取消" @click="closeCustoms" />
              <b-button
                label="產生日本海關單"
                type="is-primary"
                :disabled="!file"
                @click="onCustomsImport"
              />
            </footer>
          </div>
        </form>
      </template>
    </b-modal>
    <b-modal height="720" :active.sync="isImageModalActive">
      <p class="image">
        <img :src="helpImageUrl(showImage)" alt="" />
      </p>
    </b-modal>
    <b-modal
      v-model="isRemittanceModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <RemittanceOrderForm @send="printRemittance" />
    </b-modal>
    <b-loading :is-full-page="true" :active="isSending" :can-cancel="false" />
  </nav>
</template>
<style>
.has-text-weight-bold {
  font-family: 'Helvetica Neue', '微軟正黑體', Helvetica, Arial, sans-serif !important;
}
</style>
<script>
import { mapGetters } from 'vuex'
import { BUSINESS_ENTITY_API, LINE_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { openAdmin2 } from '@/utils/admin2'
import RemittanceOrderForm from '@/components/layouts/RemittanceOrderForm.vue'

export default {
  name: 'Navbar',
  components: { RemittanceOrderForm },

  data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      isAccountant: this.isAdmin || this.authAccountant(),
      isTagModalActive: false,
      file: null,
      displayTel: false,
      displayAddress: false,
      isSending: false,
      importStatus: null,
      importErrors: null,

      isImageModalActive: false,
      showImage: '',

      isQuestionnaireModalActive: false,
      tourLeader: '',
      height: 0,
      width: 0,

      isCustomsModalActive: false,
      airLine: '',
      depLocation: '',
      depDate1: '',
      depDate2: '',
      depDate3: '',
      hotel: '',
      hotelTel1: '',
      hotelTel2: '',
      hotelTel3: '',

      isRemittanceModalActive: false,

      isLineNotifyModalActive: false,
      lineNotifyContent: '',

      showNav: false,
      enable_locales: process.env.VUE_APP_ENABLE_SELECT_LOCALES === 'true',
      locales: [
        { code: 'zh-Hant', name: '繁體中文', iso: 'zh-Hant' },
        { code: 'en', name: 'English', iso: 'en-US' }
      ]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale()
    },
    ...mapGetters(['username']),
    ...mapGetters('app', ['hasPermission'])
  },
  methods: {
    async printRemittance(data) {
      const api = `${BUSINESS_ENTITY_API}/print-remittance`
      const config = {
        headers: { Accept: 'application/pdf' },
        responseType: 'blob',
        errorHandle: {
          customMessage: `${this.$t('attributes.fetch_failed', [
            this.$t('attributes.order')
          ])}: `
        }
      }
      const params = {
        bank_name: data.bank_name,
        bank_number: data.bank_number,
        branch_name: data.branch_name,
        account_number: data.account_number,
        account_name: data.account_name,
        amount: data.amount
      }

      try {
        this.isSending = true
        const response = await this.axios.get(api, { ...config, params })
        const dateTimeString = this.getCurrentDateTimeString()
        const fileName = `台北富邦匯款委託書-${dateTimeString}.pdf`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載申請表失敗', e)
      } finally {
        this.isSending = false
        this.isRemittanceModalActive = false
      }
    },
    getCurrentDateTimeString() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      const second = String(now.getSeconds()).padStart(2, '0')

      return `${year}${month}${day}${hour}${minute}${second}`
    },
    async logout() {
      await this.$auth.logout()
    },
    authAccountant() {
      if (!this.$auth.user()) {
        return false
      }

      const accountants = '00685,00666,017,411'
      return accountants.indexOf(this.$auth.user().emp_code) !== -1
    },
    setLanguage(locale) {
      localStorage.setItem('locale', locale)
      this.$i18n.set(locale)
    },
    async onTagImport(version) {
      if (this.file == null) {
        return
      }

      try {
        const api = `${TRAVEL_GROUPS_API}/passport`
        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob'
        }

        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('tel', this.displayTel)
        formData.append('address', this.displayAddress)
        formData.append('version', version)

        this.isSending = true
        this.importStatus = null
        this.importErrors = null

        const response = await this.axios.post(api, formData, config)

        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `標籤v${version}_${date}.xlsx`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        notifyService.success('轉換成功')
        this.isTagModalActive = false
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('轉換失敗', e)
      } finally {
        this.isSending = false
        this.file = null
      }
    },
    async onQuestionnaireImport() {
      if (this.file == null) {
        return
      }

      try {
        const api = `${TRAVEL_GROUPS_API}/questionnaire`
        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob'
        }

        if (isNaN(this.width) || isNaN(this.height)) {
          this.$buefy.dialog.alert({
            title: '錯誤',
            message: '右位移、下位移請輸入數字',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          return false
        }
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('tourLeader', this.tourLeader)
        formData.append('width', this.width)
        formData.append('height', this.height)

        this.isSending = true
        this.importStatus = null
        this.importErrors = null

        const response = await this.axios.post(api, formData, config)

        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `意調表_${date}.xlsx`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        notifyService.success('轉換成功')
        this.isTagModalActive = false
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('轉換失敗', e)
      } finally {
        this.isSending = false
        this.file = null
      }
    },
    closeQuestionnaire() {
      this.width = 0
      this.height = 0
      this.tourLeader = ''
      this.file = null
      this.isQuestionnaireModalActive = false
    },
    async onCustomsImport() {
      if (this.file == null) {
        return
      }

      try {
        const api = `${TRAVEL_GROUPS_API}/customs`
        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob'
        }

        if (this.airLine.trim() === '' || this.depLocation.trim() === '') {
          this.$buefy.dialog.alert({
            title: '錯誤',
            message: '搭乘班機 或 出發地 不可空白',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          return false
        }
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('airLine', this.airLine)
        formData.append('depLocation', this.depLocation)
        formData.append('depDate1', this.depDate1)
        formData.append('depDate2', this.depDate2)
        formData.append('depDate3', this.depDate3)
        formData.append('hotel', this.hotel)
        formData.append('hotelTel1', this.hotelTel1)
        formData.append('hotelTel2', this.hotelTel2)
        formData.append('hotelTel3', this.hotelTel3)

        this.isSending = true
        this.importStatus = null
        this.importErrors = null

        const response = await this.axios.post(api, formData, config)

        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `日本海關單_${date}.xlsx`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        notifyService.success('轉換成功')
        this.isTagModalActive = false
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('轉換失敗', e)
      } finally {
        this.isSending = false
        this.file = null
      }
    },
    closeCustoms() {
      this.airLine = ''
      this.depLocation = ''
      this.depDate1 = ''
      this.depDate2 = ''
      this.depDate3 = ''
      this.hotel = ''
      this.hotelTel1 = ''
      this.hotelTel2 = ''
      this.hotelTel3 = ''
      this.file = null
      this.isCustomsModalActive = false
      this.lineNotifyContent = ''
      this.isLineNotifyModalActive = false
    },
    onClickImage(img) {
      this.showImage = img
      this.isImageModalActive = true
    },
    async linkLineNotify() {
      try {
        const api = `${LINE_API}/link`
        this.isSending = true

        const res = await this.axios.get(api, {})
        const result = res.data

        if (result.success) {
          window.open(result.data.url, '_blank')
        } else {
          notifyService.error('取得綁定連結失敗')
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('取得綁定連結失敗', e)
      } finally {
        this.isSending = false
      }
    },
    onSendLineNotify() {
      this.lineNotifyContent = ''
      this.isLineNotifyModalActive = true
    },
    async sendLineNotify() {
      if (this.lineNotifyContent.trim() === '') {
        this.$buefy.dialog.alert({
          title: '送出失敗',
          message: '訊息內容不可空白!',
          confirmText: '確定'
        })
        this.lineNotifyContent = ''
        return false
      }
      try {
        const api = `${LINE_API}/notify`
        this.isSending = true

        const res = await this.axios.post(api, {
          content: this.lineNotifyContent
        })
        const result = res.data

        if (result.success) {
          notifyService.success('送出通知成功')
          this.isLineNotifyModalActive = false
        } else {
          notifyService.error('送出通知失敗')
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error('送出通知失敗', e)
      } finally {
        this.isSending = false
      }
    },
    async redirectToAdmin2(page) {
      try {
        const url = await openAdmin2(this.axios, page)

        if (url) {
          window.location.href = url
        }
      } catch (e) {
        notifyService.fetch_error('jwt_token', e)
      }
    }
  }
}
</script>
